// Display authority only. Position/P&L marks continue to use their existing rule.
const positive = value => value != null && value !== '' && Number.isFinite(Number(value)) && Number(value) > 0 ? Number(value) : null
export function optionDisplayPrice(quote, session) {
  return session === 'closed'
    ? positive(quote?.sessionClose) ?? positive(quote?.lastRth) ?? positive(quote?.last) ?? positive(quote?.close)
    : positive(quote?.last)
}
